<div class="">
  <form [formGroup]="searchForm">
    <div class="filter-box filterPanel">
      <div class="ui-g">
        <div class="ui-g-3 ui-sm-12">
          <p-dropdown
            name="filterIsWrapper"
            [style]="{ width: '100%' }"
            filter="true"
            (onChange)="filterCommTemplates()"
            [options]="filterIsWrapperChoices"
            formControlName="isWrapper"
          ></p-dropdown>
        </div>

        <div class="ui-g-3 ui-sm-12">
          <p-dropdown
            name="filterCommsEvent"
            [style]="{ width: '100%' }"
            filter="true"
            (onChange)="filterCommTemplates()"
            [options]="filterCommsEventChoices"
            formControlName="commsEventId"
          ></p-dropdown>
        </div>

        <div class="ui-g-3 ui-sm-12">
          <p-dropdown
            name="filterCustomerId"
            [style]="{ width: '100%' }"
            filter="true"
            (onChange)="filterCommTemplates()"
            [options]="filterCustomerChoices"
            formControlName="customerId"
          ></p-dropdown>
        </div>

        <div class="ui-g-3 ui-sm-12">
          <p-dropdown
            name="filterCommsType"
            [style]="{ width: '100%' }"
            filter="true"
            (onChange)="filterCommTemplates()"
            [options]="filterCommsTypeChoices"
            formControlName="commsType"
            label
          ></p-dropdown>
        </div>
      </div>
    </div>
  </form>

  <p-table
    #dataTable
    [value]="commsTemplates"
    [lazy]="false"
    selectionMode="single"
    [(selection)]="selectedTemplate"
    [loading]="isLoading"
    (onRowSelect)="editTemplate()"
    [rowsPerPageOptions]="[5, 10, 20]"
    [responsive]="true"
    [paginator]="true"
    [rows]="5"
    rowHover="true"
    resizableColumns="true"
  >
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="isWrapper">Type</th>
        <th pSortableColumn="templateName">Title</th>
        <th pSortableColumn="commsEvent?.commsEventCode">Event Code</th>
        <th pSortableColumn="allowDuplicate">Duplicates</th>
        <th pSortableColumn="customer">Template For</th>
        <th pSortableColumn="commsType">Comms Type</th>
        <th pSortableColumn="mergeModel">MergeModel</th>
        <th pSortableColumn="active">Active?</th>
        <th>Update</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item>
      <tr [pSelectableRow]="item">
        <td>
          <div *ngIf="item.isWrapper">Wrapper</div>
          <div *ngIf="!item.isWrapper">Content</div>
        </td>
        <td>{{ item.templateName }}</td>
        <td>
          <div *ngIf="item.isWrapper">N/A</div>
          <div *ngIf="!item.isWrapper">
            <div pTooltip="Event Code">{{ item.commsEvent?.commsEventCode }}</div>
            <div class="event-title" pTooltip="{{ item.commsEvent?.title }}">
              {{ item.commsEvent?.title }}
            </div>
          </div>
        </td>
        <td style="text-align: center">
          <i class="fa fa-check fa-2x text-success" *ngIf="item.allowDuplicate"></i>
          <i class="fa fa-times fa-2x error-color" *ngIf="!item.allowDuplicate"></i>
        </td>
        <td>
          <div pTooltip="Customer">
            {{ item?.customer ? item.customer.Name : 'Default Template' }}
          </div>
        </td>
        <td>
          <div pTooltip="Comms Type">{{ CommsTypeName[item.commsType] }}</div>
        </td>
        <td>
          <div *ngIf="item.isWrapper">N/A</div>
          <div *ngIf="!item.isWrapper" pTooltip="Merge Model">
            {{ MergeModelName[item.commsEvent.mergeModel] }}
          </div>
        </td>
        <td style="text-align: center">
          <i class="fa fa-check fa-2x text-success" *ngIf="item.active"></i>
          <i class="fa fa-times fa-2x error-color" *ngIf="!item.active"></i>
        </td>
        <td>
          <div pTooltip="Updated">{{ item.updated | date : 'dd/MM/yy HH:mm' }}</div>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <!--- DATATABLES DEPRECATED ---

  <p-dataTabl #dataTable [value]="commsTemplates" [lazy]="false"
               selectionMode="single"
               [(selection)]="selectedTemplate"
               [loading]="isLoading"
               (onRowSelect)="editTemplate()"
               [rowsPerPageOptions]="[5,10,20]"
               [responsive]="true" [paginator]="true" [rows]="5" rowHover="true" resizableColumns="true">

    <p-column field="isWrapper" header="Type" [sortable]="tru" [editable]="false"
              pTooltip="Template Type" [style]="{'width':'100px'}">
      <ng-template pTemplate="commsEvent.isWrapper" let-item="rowData">
        <div *ngIf="item.isWrapper">
          Wrapper
        </div>
        <div *ngIf="!item.isWrapper">
          Content
        </div>
      </ng-template>
    </p-column>
    <p-column field="title" header="Title" [sortable]="tru" [editable]="false"
              pTooltip="Template Title" [style]="{'width':'100px'}">
      <ng-template pTemplate="body" let-item="rowData">
        {{ item.templateName }}
      </ng-template>
    </p-column>
    <p-column field="commsEvent.commsEventCode" header="Event Code" [sortable]="tru" [editable]="false"
              pTooltip="Event Code">
      <ng-template pTemplate="commsEvent.commsEventCode" let-item="rowData">
        <div *ngIf="item.isWrapper">
          N/A
        </div>
        <div *ngIf="!item.isWrapper">
          <div pTooltip="Event Code">{{ item.commsEvent?.commsEventCode }}</div>
          <div class="event-title" pTooltip="{{item.commsEvent?.title}}">{{item.commsEvent?.title}}</div>
        </div>
      </ng-template>
    </p-column>
    <p-column field="commsEvent.allowDuplicate" header="Duplicates" [sortable]="tru" [editable]="false"
              [style]="{'max-width':'100px', 'text-align':'center'}">
      <ng-template pTemplate="body" let-item="rowData">
        <i class="fa fa-check fa-2x text-success" *ngIf="item.allowDuplicate"></i>
        <i class="fa fa-times fa-2x error-color" *ngIf="!item.allowDuplicate"></i>

      </ng-template>
    </p-column>
    <p-column field="customer.name" header="Template For" [sortable]="tru" [editable]="false" pTooltip="test">
      <ng-template pTemplate="body" let-item="rowData">
        <div pTooltip="Customer">{{
          (item?.customer) ? item.customer.Name : 'Default Template'
          }}</div>
      </ng-template>
    </p-column>
    <p-column field="commsType" header="Comms Type" [sortable]="tru" [editable]="false"
              pTooltip="test">
      <ng-template pTemplate="body" let-item="rowData">
        <div pTooltip="Comms Type">{{ CommsTypeName[item.commsType] }}</div>
      </ng-template>
    </p-column>
    <p-column field="commsEvent.mergeModelName" header="MergeModel" [sortable]="tru" [editable]="false"
              pTooltip="test">
      <ng-template pTemplate="body" let-item="rowData">
        <div *ngIf="item.isWrapper">N/A</div>
        <div *ngIf="!item.isWrapper" pTooltip="Merge Model">{{ MergeModelName[item.commsEvent.mergeModel] }}</div>
      </ng-template>
    </p-column>
    <p-column field="updated" header="Updated" [sortable]="tru" [editable]="false" pTooltip="test"
              [style]="{'width':'120px'}">
      <ng-template pTemplate="updated" let-item="rowData">
        <div pTooltip="Updated">{{ item.updated | date: "dd/MM/yy HH:mm" }}</div>
      </ng-template>
    </p-column>
  </p-dataTable>

  -->

  <div class="footerPanel ui-g">
    <button
      type="button"
      class="btn-to-right"
      pButton
      icon="fa ui-icon-plus"
      (click)="addTemplate()"
      label="Template"
    ></button>
    <button
      type="button"
      class="btn-to-right"
      (click)="editTemplate()"
      label="Edit"
      pButton
      icon="fa ui-icon-mode-edit"
      [disabled]="!selectedTemplate"
    ></button>
    <!--
    <button type="button" class="btn-to-right" pButton icon="fa ui-icon-arrow-thick-2-e-w"
            [disabled]="!selectedItem"
            (click)="copyTemplate()" label="Copy"></button>
            -->
    <button
      type="button"
      class="btn-to-right"
      pButton
      icon="fa ui-icon-trash"
      [disabled]="!selectedTemplate"
      (click)="deleteTemplate()"
      label="Delete"
    ></button>
  </div>
</div>

<p-dialog
  #customerTaggingDialog
  header="Include / Exclude Customers from Event Template"
  [(visible)]="showDisabledFor"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '750px' }"
>
  <div class="ui-g">
    <div class="ui-g-6">
      <p-table
        [value]="includedCustomers"
        [rows]="10"
        [paginator]="true"
        selectionMode="single"
        [(selection)]="excludeItem"
        #dt
      >
        <ng-template pTemplate="header">
          <tr>
            <th>Included Customers</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <tr (dblclick)="moveToExcluded(item)" [pSelectableRow]="item">
            <td>{{ item.label }}</td>
          </tr>
        </ng-template>
      </p-table>

      <!-- DEPRECATED --
      <p-dataTabl [value]="includedCustomers" [rows]="10" [paginator]="true"
                   selectionMode="single"
                   [(selection)]="excludeItem"
                   (onRowDblclick)="moveToExcluded($event)" #dt>
        <p-column field="label" header="Included Customers" [filter]="true" filterMatchMode="contains">
          <ng-template pTemplate="body" let-item="rowData" let-i="rowIndex">
            {{ item.label }}
          </ng-template>
        </p-column>
      </p-dataTable>
      -->
    </div>
    <div class="ui-g-6">
      <p-table
        [value]="excludedCustomers"
        [rows]="10"
        [paginator]="true"
        selectionMode="single"
        [(selection)]="includeItem"
        #dt2
      >
        <ng-template pTemplate="header">
          <tr>
            <th>Excluded Customers</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <tr (dblclick)="moveToIncluded(item)" [pSelectableRow]="item">
            <td>{{ item.label }}</td>
          </tr>
        </ng-template>
      </p-table>

      <!-- DEPRECATED --
      <p-dataTabl [value]="excludedCustomers" [rows]="10" [paginator]="true"
                   selectionMode="single"
                   [(selection)]="includeItem"
                   (onRowDblclick)="moveToIncluded($event)" #dt2>
        <p-column field="label" header="Excluded Customers" [filter]="true" filterMatchMode="contains">
          <ng-template pTemplate="body" let-item="rowData" let-i="rowIndex">
            {{ item.label }}
          </ng-template>
        </p-column>
      </p-dataTable>

      -->
    </div>
    <div class="text-align: right;">
      <button
        type="button"
        class="btn-to-right"
        pButton
        (click)="showDisabledFor = false"
        label="Close"
      ></button>
    </div>
  </div>
</p-dialog>

<p-dialog
  [style]="{ height: '800px', 'overflow-y': 'auto', width: '1024px' }"
  [responsive]="true"
  [header]="'Template Details'"
  [modal]="true"
  [(visible)]="showEditForm"
>
  <form [formGroup]="formGroup">
    <input type="hidden" formControlName="id" id="id" />

    <div class="ui-g" style="padding-top: 10px">
      <div class="ui-g-12 pb-1">
        <div class="flex flex-wrap">
          <div class="flex-shrink-1 input-label">
            <b>Is a Wrapper:</b>
          </div>

          <div class="flex-shrink-1">
            <p-checkbox formControlName="isWrapper" binary="true"></p-checkbox>
            <i
              class="fa fa-question-circle tooltip"
              [tooltipStyleClass]="'xtooltip'"
              [escape]="false"
              pTooltip="Is this template going to be used as a wrapper for other templates"
            ></i>
          </div>
        </div>
      </div>
      <div class="ui-g-12 pb-1">
        <div class="flex flex-wrap">
          <div class="flex-shrink-1 input-label">
            <b>Active?</b>
          </div>

          <div class="flex-shrink-1">
            <p-checkbox formControlName="active" binary="true"></p-checkbox>
            <i
              class="fa fa-question-circle tooltip"
              [tooltipStyleClass]="'xtooltip'"
              [escape]="false"
              pTooltip="If the template is inactive, no content will be sent through this template"
            ></i>
          </div>
        </div>
      </div>
      <div class="ui-g-12">
        <div class="flex flex-wrap">
          <div class="flex-shrink-1 input-label">
            <b>Title:</b>
          </div>
          <div class="flex-grow-1">
            <input
              pInputText
              id="templateName"
              formControlName="templateName"
              style="min-width: 300px"
            />
          </div>
        </div>
      </div>

      <div class="ui-g-12">
        <div class="flex flex-wrap">
          <div class="flex-shrink-1 input-label">
            <b>Event Code:</b>
          </div>
          <div class="flex-grow-1">
            <p-dropdown
              name="commsEvent"
              [style]="{ width: '100%' }"
              filter="true"
              (onChange)="changedCommsEvent($event.value)"
              [options]="commsEventChoices"
              id="commsEventId"
              formControlName="commsEventId"
            ></p-dropdown>
          </div>
        </div>
      </div>

      <div class="ui-g-12">
        <div class="flex flex-wrap">
          <div class="flex-shrink-1 input-label" style="padding-top: 10px">
            <b>Template For:</b>
          </div>
          <div class="flex-grow-1">
            <div style="padding-top: 10px; padding-bottom: 10px">
              <p-dropdown
                name="customerId"
                [style]="{ width: '100%' }"
                filter="true"
                [options]="customerChoices"
                id="customerId"
                formControlName="customerId"
              ></p-dropdown>
            </div>
          </div>

          <div class="flex-shrink-1 input-label">
            <div *ngIf="f.customerId == null">
              <button
                (click)="showDisabledFor = true"
                pButton
                [label]="'Disabled for ' + excludedCount + ' Customers'"
              ></button>
            </div>
          </div>
        </div>
      </div>

      <div class="ui-g-12" *ngIf="!f.isWrapper">
        <div class="flex flex-wrap">
          <div class="flex-shrink-1 input-label">
            <b>Allow Duplicates:</b>
          </div>
          <div class="flex-grow-1">
            <p-checkbox formControlName="allowDuplicate" binary="true"></p-checkbox>
            &nbsp; <b>Unique Id:</b>
            <input
              pInputText
              [placeholder]="uniquePlaceholder"
              formControlName="uniqueIdTemplate"
            />
            <i
              class="fa fa-question-circle tooltip"
              [tooltipStyleClass]="'xtooltip'"
              [escape]="false"
              pTooltip="The value used to determine duplicates, if left empty will default to {{
                uniquePlaceholder
              }}"
            ></i>
            <span style="font-size: 12px"></span>
          </div>
        </div>
      </div>

      <!--
      -->

      <div class="ui-g-12">
        <div class="flex flex-wrap">
          <div class="flex-shrink-1 input-label"><b>Delivery Method:</b></div>
          <div class="flex-grow-1">
            <p-dropdown
              name="commsType"
              [style]="{ width: '100%' }"
              filter="true"
              [options]="commsTypeChoices"
              id="commsType"
              formControlName="commsType"
            ></p-dropdown>
          </div>
        </div>
      </div>

      <div class="ui-g-12" *ngIf="f.commsType == 2">
        <div class="flex flex-wrap">
          <div class="flex-shrink-1 input-label"><b>SMS SID:</b></div>
          <div class="flex-grow-1">
            <input pInputText id="senderName" formControlName="senderName" style="width: 200px" />
            <i
              class="fa fa-question-circle tooltip"
              [tooltipStyleClass]="'xtooltip'"
              [escape]="false"
              pTooltip="The sender name that will show on the text"
            ></i>
            <span style="font-size: 12px">(Max length 11 characters)</span>
          </div>
        </div>
      </div>

      <div class="ui-g-12" *ngIf="!f.isWrapper">
        <div class="flex flex-wrap">
          <div class="flex-shrink-1 input-label"><b>Wrapper:</b></div>

          <div class="flex-shrink-1">
            <p-dropdown
              name="wrapperId"
              [style]="{ width: '300px' }"
              filter="true"
              [options]="wrapperChoices"
              id="wrapperId"
              formControlName="wrapperId"
            ></p-dropdown>
          </div>

          <div class="flex-shrink-1" *ngIf="f.wrapperId > 0">
            <button pButton (click)="editTemplate(f.wrapperId)" label="Edit Wrapper"></button>
          </div>
        </div>
      </div>
    </div>

    <div class="ui-g" *ngIf="!f.isWrapper">
      <div class="ui-g-12">
        <div class="flex flex-wrap">
          <div class="input-label flex-shrink-1">
            <label for="recipientAddress"><b>Recipient Address:</b></label>
          </div>
          <div class="flex-grow-1">
            <textarea
              pInputTextarea
              id="recipientAddress"
              formControlName="recipientAddress"
              style="width: 100%; height: 50px"
            >
            </textarea>
          </div>
        </div>
      </div>
    </div>

    <div class="ui-g" *ngIf="!f.isWrapper">
      <div class="ui-g-12">
        <div class="flex flex-wrap">
          <div class="input-label flex-shrink-1">
            <label for="bccAddress"><b>Bcc Address:</b></label>
          </div>
          <div class="flex-grow-1">
            <textarea
              pInputTextarea
              id="bccAddress"
              formControlName="bccAddress"
              style="width: 100%; height: 50px"
            >
            </textarea>
          </div>
        </div>
      </div>
    </div>

    <div class="ui-g" *ngIf="f.commsType == 1 && !f.isWrapper">
      <div class="ui-g-12">
        <div class="flex flex-wrap">
          <div class="flex-shrink-1 input-label">
            <label for="subjectTemplate">Subject:</label>
          </div>
          <div class="flex-grow-1">
            <textarea
              pInputTextarea
              style="height: 50px; width: 100%"
              id="subjectTemplate"
              placeholder="Enter Subject Content Here"
              formControlName="subjectTemplate"
            ></textarea>
          </div>
        </div>
      </div>
    </div>

    <div class="ui-g">
      <div class="ui-g-12">
        <div class="flex flex-wrap w-100">
          <div class="flex-shrink-1 input-label">
            <label for="templateFile">Template File:</label>
          </div>

          <div class="flex-grow-1">
            <p-dropdown
              name="templateFile"
              [style]="{ width: '300px' }"
              filter="true"
              [options]="templateFileChoices"
              id="templateFile"
              formControlName="templateFile"
            ></p-dropdown>
          </div>
        </div>
      </div>
    </div>

    <div class="ui-g" *ngIf="f.templateFile == 'None' || f.templateFile == null">
      <div class="ui-g-12">
        <div class="flex flex-wrap w-100">
          <div class="flex-shrink-1 input-label">
            <label for="bodyTemplate">Body:</label>
          </div>

          <div class="flex-grow-1">
            <textarea
              (keyup)="checkTemplateSyntax(f.bodyTemplate)"
              pInputTextarea
              id="bodyTemplate"
              placeholder="Enter Body Content Here"
              spellcheck="false"
              style="min-height: 150px; width: 100%"
              formControlName="bodyTemplate"
            ></textarea>
            <div *ngIf="bracketDifference < 0" class="error-color">
              <span ngNonBindable>Opening {{ missing }}</span>
            </div>
            <div *ngIf="bracketDifference > 0" class="error-color">
              <span ngNonBindable>{{ Closing }} missing</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="ui-g" *ngIf="f.commsType == 1 && !f.isWrapper && selectedTemplate">
      <div class="ui-g-12">
        <div class="flex flex-wrap">
          <div class="flex-shrink-1 input-label">
            <label>Template Attachments:</label>
          </div>
          <div class="flex-grow-1">
            <app-comms-attachments [templateId]="selectedTemplate.id"></app-comms-attachments>
          </div>
        </div>
      </div>
    </div>

    <div
      class="flex flex-wrap"
      style="background-color: #eee; margin-top: 10px; margin-bottom: 10px"
    >
      <div class="flex-shrink-1 input-label" style="line-height: 40px">
        <i
          class="fa fa-question-circle tooltip"
          [tooltipStyleClass]="'xtooltip'"
          [escape]="false"
          pTooltip="<b>To test a template:</b><br>Enter the ID of the source model (eg, a task Id) in the ModelID, and click <b>Preview Template</b></br><b>To receive a copy by Email/SMS:</b><br>Enter your Email/mobile number in <b>Preview Recipient</b> and click <b>Send Test</b>"
        ></i>
        <b>Preview:</b>
      </div>
      <div class="flex-shrink-1 mr-1" style="padding-top: 5px">
        <label for="previewId">Model ID: </label>
        <input pInputText id="previewId" formControlName="previewId" style="min-width: 100px" />
        <button
          pButton
          label="Show Model"
          (click)="showPreviewModel()"
          [disabled]="!canPreview()"
          class="mr-1"
        ></button>
      </div>

      <div class="flex-shrink-1 mr-1" style="line-height: 40px">
        <label for="previewRecipient">Preview Recipient: </label>
        <input
          pInputText
          id="previewRecipient"
          formControlName="previewRecipient"
          style="min-width: 100px"
        />
      </div>
    </div>

    <div class="text-right">
      <button pButton label="Cancel" (click)="closeEditForm()"></button>
      <button pButton label="Send Test" (click)="sendTest()" [disabled]="!canSendTest()"></button>
      <button
        pButton
        label="Preview Template"
        (click)="preview()"
        [disabled]="!canPreview()"
      ></button>
      <button pButton label="Save Changes" (click)="save()" [disabled]="!canSave()"></button>
    </div>
  </form>

  <div class="mt-3">
    <p-accordion>
      <p-accordionTab header="Functions">
        <div style="font-weight: bold; font-size: 13px; line-height: 15px; padding-bottom: 7px">
          NOTE: All functions must be preceeded by a <b>|</b> symbol, eg. task.CompletedDateTime |
          modify_hours: 3
        </div>
        <li>
          <strong>modify_days: X</strong> Modify the datetime by X days (can be a positive or
          negative value)
        </li>
        <li>
          <strong>modify_hours: X</strong> Modify the datetime by X hours (can be a positive or
          negative value)
        </li>
        <li>
          <strong>modify_minutes: X</strong> Modify the datetime by X minutes (can be a positive or
          negative value)
        </li>
        <li>
          <strong>plus_time_span: X</strong> Add a timespan (eg. Task.EstimatedTime) to the datetime
        </li>
        <li>
          <strong>minus_time_span: X</strong> Subtract a timespan (eg. Task.EstimatedTime) to the
          datetime value
        </li>
        <li>
          <strong>minus_time_span: X</strong> Subtract a timespan (eg. Task.EstimatedTime) to the
          datetime value
        </li>
        <li>
          <strong>minus_time_span: X</strong> Subtract a timespan (eg. Task.EstimatedTime) to the
          datetime value
        </li>
        <li><strong>metres_to_miles</strong> Converts the value from metres to miles.</li>
        <li><strong>round: X</strong> Rounds a decimal to X decimal places.</li>
      </p-accordionTab>
    </p-accordion>
  </div>
</p-dialog>

<p-dialog
  header="Preview Model"
  [(visible)]="previewModel"
  [style]="{ height: '300px', 'overflow-y': 'auto', width: '750px' }"
  [responsive]="true"
  [modal]="true"
>
  <div *ngIf="previewModel != null && previewModel.hash != null">
    <ngx-json-viewer [json]="previewModel?.hash"></ngx-json-viewer>
  </div>
</p-dialog>

<p-dialog
  header="Preview Response"
  [(visible)]="previewResponse"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '750px' }"
>
  <div class="ui-g-12" *ngIf="previewResponse != null">
    <div *ngIf="!previewResponse.success">TEMPLATE ERROR</div>

    <div *ngIf="previewResponse.recipientAddress">
      Recipient Address
      <div class="preview">{{ previewResponse.recipientAddress }}</div>
    </div>
    <div *ngIf="previewResponse.bccAddress" class="mt-2">
      BCC Address
      <div class="preview">{{ previewResponse.bccAddress }}</div>
    </div>
    <div *ngIf="previewResponse.subject">
      Subject
      <div class="preview">{{ previewResponse.subject }}</div>
    </div>
    <div *ngIf="previewResponse.body" class="mt-2">
      Body

      <span class="display-toggle" (click)="showText = true">Text</span>
      <span class="display-toggle" (click)="showText = false">HTML</span>

      <div *ngIf="showText" class="text-preview preview">{{ previewResponse.body }}</div>
      <div *ngIf="!showText" class="html-preview preview" [innerHTML]="previewResponse.body"></div>
    </div>
    <div class="mt-2">
      Unique Id
      <div class="preview">{{ previewResponse.uniqueId }}</div>
    </div>
  </div>
</p-dialog>

<ng-template #loading>Loading...</ng-template>
